import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=57dbc9ca"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports